import { render, staticRenderFns } from "./buyCouponPay.vue?vue&type=template&id=01cd8bbf&scoped=true&"
import script from "./buyCouponPay.vue?vue&type=script&lang=js&"
export * from "./buyCouponPay.vue?vue&type=script&lang=js&"
import style0 from "./buyCouponPay.vue?vue&type=style&index=0&id=01cd8bbf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd8bbf",
  null
  
)

export default component.exports